import { createFileRoute } from '@tanstack/react-router'
import { SupportScreen } from '@/features/support/support'

/**
 * Route shell for the support-access screen — plan 05 Task 13.
 *
 * Per the route-shell rule, this file is a route definition and a render.
 * The screen lives in `src/features/support/`.
 */
export const Route = createFileRoute('/_authenticated/support')({
  component: SupportScreen,
})
